module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-BookItalic-WebM-7223c27db9d3687692ed114ad244b1b2.woff2";